import { preventDivision } from '@/services/tools'

const getUserPlayersWithStats = (sections, stats) => {
  return sections.map(section => {
    section._players = section._players.map(player => {
      player.sectionId = section.id || section.sectionId
      player.count = 0
      const statPlayer = stats.filter(p => p.id === player.id)
      if (statPlayer.length) {
        player.count = statPlayer[0].count
      }
      player.active = true
      player.percent = null
      return player
    })
    return section
  })
}

const getOtherPlayersWithStats = (sections, userPlayers, stats, totalCount) => {
  userPlayers = [].concat(...userPlayers.map(section => {
    return section._players
  }))
  return sections.map(section => {
    section._players = section._players.map(player => {
      player.sectionId = section.id || section.sectionId
      if (userPlayers.filter(pl => pl.id === player.id).length > 0) {
        player.active = true
      }
      player.count = 0
      const statPlayer = stats.filter(p => p.id === player.id)
      if (statPlayer.length) {
        player.count = statPlayer[0].count
      }
      player.percent = Math.round((player.count * 100) / preventDivision(totalCount))
      return player
    })
    return sortSection(section)
  })
}

const sortSection = (section) => {
  section._players = section._players.sort((a, b) => {
    if (a.count < b.count) return 1
    if (a.count > b.count) return -1
    return 0
  })
  return section
}

export {
  getUserPlayersWithStats,
  getOtherPlayersWithStats
}



// WEBPACK FOOTER //
// ./src/services/utils.js